module.exports = __webpack_public_path__ + "img/IT0000643840357.6580cc08.png";